import React, { useState } from 'react';
import {
  FaCalendarAlt,
  FaCog,
  FaExternalLinkAlt,
  FaFileAlt,
  FaMapMarkerAlt,
  FaTrophy,
  FaUsers,
  FaClock
} from 'react-icons/fa';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { GiPlantSeed, GiProcessor } from 'react-icons/gi';
import { MdGroups, MdOutlineLayers } from 'react-icons/md';
import Navbar from '../components/navbar';
import Footer from '../components/Footer';
import PageHeader from '../about/PageHeader';
import './NationalConference.css';

const NationalConference = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

const carouselImages = [
  { src: '/National-Conference/MCA00146.JPG', alt: 'Healthcare innovation discussion' },
  { src: '/National-Conference/MCA00178.JPG', alt: 'AI research panel' },
  { src: '/National-Conference/MCA00286.JPG', alt: 'Sustainable development conference' },
  { src: '/National-Conference/MCA00303.JPG', alt: 'Conference presentation session' },
  { src: '/National-Conference/MCA00371.JPG', alt: 'Award distribution and felicitation' },
  { src: '/National-Conference/MCA09982.JPG', alt: 'Guest speaker facilitation' },
  { src: '/National-Conference/MCA09986.JPG', alt: 'Plant sapling presentation ceremony' },
  { src: '/National-Conference/MCA09997.JPG', alt: 'Dignitaries on stage during inauguration' }
];
  const nextSlide = () => setCurrentSlide((prev) => (prev === carouselImages.length - 1 ? 0 : prev + 1));
  const prevSlide = () => setCurrentSlide((prev) => (prev === 0 ? carouselImages.length - 1 : prev - 1));

  const thematicTalks = [
    {
      title: 'AI in Agriculture - Agro-Genetic Intelligence',
      time: '28 November 2025 | 10:15 am - 10:45 am',
      speaker: 'Dr. Prakash Jha',
      org: 'Mississippi State University',
      desc: 'Dr. Jha showcased cutting-edge AI applications in modern agriculture, including crop phenology modeling, intelligent irrigation systems, ClimAID climate dashboards, SMART Bay systems, soil carbon spectral analysis, and greenhouse gas monitoring. The session concluded with an interactive Q&A.'
    },
    {
      title: 'AI in Medicine - Doing More with Less',
      time: '28 November 2025 | 10:45 am - 11:15 am',
      speaker: 'Dr. Sabyaschi Sengupta',
      org: 'Founder & Director, Chief Vitreo Retina Surgeon, Future Vision Eye Care and Research Centre',
      desc: 'Dr. Sengupta discussed AI-driven medical innovations such as disease detection, retinal imaging, and scalable healthcare solutions that enhance access to affordable, high-quality medical care.'
    },
    {
      title: "A Strategic Roadmap for India's Energy Independence and Decarbonization by 2047",
      time: '28 November 2025 | 11:15 am - 11:45 am',
      speaker: 'Dr. Lov Kher',
      org: '',
      desc: "Dr. Kher delivered insights into India's journey toward energy independence, climate priorities, sustainable energy transitions, and the emerging hydrogen ecosystem."
    },
    {
      title: 'Circularity & Sustainability in Business: Enablers of a Viksit Bharat',
      time: '28 November 2025 | 01:15 pm - 01:45 pm',
      speaker: 'Ms. Kripa Gopalan',
      org: 'Development Sector and Healthcare Domain Consultant',
      desc: "Ms. Gopalan discussed inclusive sustainability initiatives for youth, women, farmers, and marginalized communities, along with India's advancements in circular economies across plastics, textiles, and electronics."
    },
    {
      title: 'Maximizing Healthspan with AI',
      time: '28 November 2025 | 01:45 pm - 02:15 pm',
      speaker: "Mr. Nicholas Lee D'Souza",
      org: 'Senior Software Engineer Consultant, AI Nexus Healthcare',
      desc: "Mr. D'Souza introduced the miaHealth platform, featuring rapid assessment tools, cognitive AI engines, and innovative face- and finger-based vital scanning technologies."
    }
  ];

  const awardsData = [
    { track: 'AI for Agriculture and Healthcare', trackClass: 'text-green', award: 'First', title: 'FutureGen - Predicting Genetic Health', authors: 'Soham Borage, Rama Bansode, Tanay Prabhakar Pandit, Omkar Kamble, Shaikh, Bhavesh santosh katkar, Mohammed Zaid Manzoor' },
    { track: 'AI for Agriculture and Healthcare', trackClass: 'text-green', award: 'Second', title: 'AI-Enabled Linear Regression Model for Spectroscopic Milk Adulteration Analysis', authors: 'Vrishali M. Patil, Dr. Savita Bhosale' },
    { track: 'Emerging Technologies in IT', trackClass: 'text-blue', award: 'First', title: 'AI-Powered Quality Control and Construction Monitoring for Digital Transformation in Future Cities', authors: 'Dev Biswas, Dr. Karthik Nagarajan, Rajesh Narwade' },
    { track: 'Emerging Technologies in IT', trackClass: 'text-blue', award: 'Second', title: 'Autonomous Agent Contracts for Adaptive Supply Chains', authors: 'Bhargav Chebrolu' },
    { track: 'Application of IT in Multidisciplinary Areas', trackClass: 'text-teal', award: 'First', title: 'Optical Fiber Concrete: The Future of Sustainable Urban Infrastructure', authors: 'Mukesh Patil, Dr. Karthik Nagarajan, Mr. Raju Narwade' },
    { track: 'Application of IT in Multidisciplinary Areas', trackClass: 'text-teal', award: 'Second', title: 'AI in Education: Adaptive Learning and Analytics', authors: 'Vaishvi Vaidya, Yashasvi Jariwala, Gayatri Kapadia' },
    { track: 'IT in Management', trackClass: 'text-purple', award: 'Winner', title: 'The Glitz in Fashion Industry Powered by AI', authors: 'Pratiksha Dongre, Suchitra Srivastava, Yogendra Singh Thakur, Swati Rathore, Sonal Kanungo Sharma' }
  ];

  return (
    <>
      <Navbar />
      <PageHeader
        title="National Conference"
        crumbs={[
          { label: 'Home', href: '/' },
          { label: 'Research & Development' },
          { label: 'National Conference' }
        ]}
      />

      <main className="NationalConference-container">
        <section className="NationalConference-hero">
<div className="NationalConference-kicker-row">
            <div className="NationalConference-sponsor-badge">
              <FaCog /> AICTE Sponsored National Conference
            </div>
          </div>

          <div className="NationalConference-meta">
            <span><FaCalendarAlt /> 28 - 29 November 2025</span>
            <span className="NationalConference-meta-divider"></span>
            <span><FaMapMarkerAlt /> Mumbai, India</span>
          </div>

          <div className="NationalConference-banner-slider">
            <button className="NationalConference-slider-nav left" type="button" onClick={prevSlide} aria-label="Previous conference image">
              <FiChevronLeft />
            </button>
            <img
              src={carouselImages[currentSlide].src}
              alt={carouselImages[currentSlide].alt}
              className="NationalConference-banner-img"
            />
            <button className="NationalConference-slider-nav right" type="button" onClick={nextSlide} aria-label="Next conference image">
              <FiChevronRight />
            </button>

            <div className="NationalConference-slider-dots">
              {carouselImages.map((_, index) => (
                <button
                  type="button"
                  key={index}
                  className={`dot ${currentSlide === index ? 'active' : ''}`}
                  onClick={() => setCurrentSlide(index)}
                  aria-label={`Show conference image ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </section>

        <section className="NationalConference-stats">
          {[
            { icon: <FaCalendarAlt />, val: '2', lab: 'Days' },
            { icon: <FaUsers />, val: '10+', lab: 'Speakers' },
            { icon: <FaFileAlt />, val: '50', lab: 'Selected Papers' },
            { icon: <MdOutlineLayers />, val: '4', lab: 'Tracks' }
          ].map((stat, i) => (
            <div key={i} className="NationalConference-stat-card">
              <span className="icon">{stat.icon}</span>
              <div><h3>{stat.val}</h3><p>{stat.lab}</p></div>
            </div>
          ))}
        </section>

        <section id="about" className="NationalConference-about">
          <div className="NationalConference-about-content">
            <h2>Conference Overview</h2>
            <p>
              TIMSCDR hosted AICTE sponsored National Conference organized under the AQIS Scheme
              (GOC 2025-26) on the theme <strong>"Leveraging Information Technology for Sustainability
              in Agriculture & Healthcare - Viksit Bharat"</strong> on 28-29 November 2025.
            </p>
            <p>
              The conference brought together distinguished academicians, industry experts,
              researchers, and students to explore the transformative role of Information Technology
              in Agriculture and Healthcare in driving sustainability, innovation, and development
              toward a Viksit Bharat.
            </p>

            <div className="NationalConference-narrative-box">
              <h4>28 November 2025: Inaugural Session</h4>
              <p>
                The first day of the AICTE Sponsored National Conference commenced with the inaugural
                session, graced by esteemed guests. The Hon'ble Chief Guest, Chairman, AICTE
                <strong> Prof. T. G. Sitharam</strong> and Guest of Honor,
                <strong> Ms. Viloo Williams</strong>, Director of Healthcare Practice at Univitt-AI,
                inaugurated the conference.
              </p>
              <p>
                Other eminent dignitaries included Dr. Lov Kher, Managing Principal & Fellow,
                Solution Architecture, Verizon; Prof. Kranti Kumar, former Principal of Thadomal
                Shahani Engineering College, Mumbai; Dr. Pravin Gundalwar, General Conference Chair
                and Director of TIMSCDR; Prof. Sonu Gupta, Conference Coordinator and Deputy Director
                of TIMSCDR; and Dr. Padma Mishra, Conference Co-Coordinator and Associate Professor
                at TIMSCDR.
              </p>
              <p>
                Prof. T. G. Sitharam, in his online inaugural address, delivered a speech on the
                transformation of learning from traditional methods to the National Education Policy
                (NEP) framework. He highlighted how the NEP has made learning more flexible and
                student-centric, fostering innovation, interdisciplinary approaches, and skill
                development.
              </p>
            </div>
          </div>

          <div className="NationalConference-about-features">
            <div className="feature-item">
              <GiPlantSeed />
              <span>Sustainable Agro-Tech Ecosystems</span>
            </div>
            <div className="feature-item">
              <GiProcessor />
              <span>AI Innovation & Infrastructure</span>
            </div>
            <div className="feature-item">
              <MdGroups />
              <span>Collaborative Tech Forums</span>
            </div>
            <div className="feature-item">
              <FaTrophy />
              <span>Best Research Paper Awards</span>
            </div>
          </div>
        </section>

        <section id="schedule" className="NationalConference-schedule-section">
          <div className="NationalConference-day-card highlight">
            <div className="NationalConference-day-header">
              <FaCalendarAlt /> 28 November 2025
            </div>

            <h4 className="NationalConference-text-center" style={{ margin: '20px 0 15px' }}>
              Thematic Talks
            </h4>

            <div className="NationalConference-talk-cards-container">
              {thematicTalks.map((talk, idx) => (
                <div key={idx} className="NationalConference-talk-card">
                  <div className="talk-header">
                    <h5>{talk.title}</h5>
                    <span className="talk-time"><FaClock /> {talk.time}</span>
                  </div>
                  <div className="talk-speaker">
                    <strong>Speaker: {talk.speaker}</strong>
                    {talk.org && <span> {talk.org}</span>}
                  </div>
                  <p className="talk-desc">{talk.desc}</p>
                </div>
              ))}

              <div className="NationalConference-talk-card highlight-forum">
                <div className="talk-header">
                  <h5>Open Forum - Sustainable Technologies Accelerating Viksit Bharat 2047</h5>
                  <span className="talk-time"><FaClock /> 28 November 2025 | 02:45 pm - 03:30 pm</span>
                </div>
                <div className="talk-speaker">
                  <strong>Moderator:</strong> Ms. Kripa Gopalan<br />
                  <strong>Panelists:</strong> Dr. Lov Kher, Mr. Uday Singh, Mr. Nicholas D'Souza, Dr. Richa Singh
                </div>
                <p className="talk-desc">
                  An engaging open forum brought together experts to discuss the role of digital
                  innovation, sustainability practices, and scalable technologies in accelerating
                  India's progress toward Viksit Bharat 2047. The panelists shared insights on
                  innovative approaches and collaborative strategies to achieve sustainable
                  development goals.
                </p>
              </div>
            </div>
          </div>

          <div className="NationalConference-day-card">
            <div className="NationalConference-day-header">
              <FaCalendarAlt /> 29 November 2025
            </div>

            <p>
              The second day of the AICTE-Sponsored National Conference commenced with parallel
              paper presentation sessions from 9:30 am to 1:30 pm, covering multiple tracks:
              Track 1 - AI for Agriculture and Healthcare, Track 2 - Emerging Technologies in IT,
              Track 3 - Application of IT in Multidisciplinary Areas, and Track 4 - IT in Management.
            </p>

            <ul className="NationalConference-timeline">
              <li>
                <div className="time">09:30 am - 01:30 pm</div>
                <div className="event">Parallel Paper Presentation Sessions</div>
              </li>
            </ul>

            <h4 style={{ color: 'var(--tm-text)', margin: '20px 0 10px' }}>Parallel Track Breakdowns</h4>
            <div className="NationalConference-tracks-grid">
              <div className="track-item"><strong>Track 1:</strong> AI for Agriculture and Healthcare</div>
              <div className="track-item"><strong>Track 2:</strong> Emerging Technologies in IT</div>
              <div className="track-item"><strong>Track 3:</strong> Application of IT in Multidisciplinary Areas</div>
              <div className="track-item"><strong>Track 4:</strong> IT in Management</div>
            </div>

            <h4 style={{ color: 'var(--tm-text)', margin: '25px 0 10px' }}>Experts Who Chaired the Sessions</h4>
            <div className="NationalConference-chairs-grid">
              <div className="chair-item"><strong>Uday Pandit Khot</strong><br /><span>Professor, St. Francis Institute of Technology (SFIT)</span></div>
              <div className="chair-item"><strong>Swati Chopade</strong><br /><span>Assistant Professor, VJTI, Mumbai</span></div>
              <div className="chair-item"><strong>Sheetal Rathi</strong><br /><span>Professor & Dean (Academic), Thakur College of Engineering & Technology</span></div>
              <div className="chair-item"><strong>Rajesh S. Bansode</strong><br /><span>Professor & Head IT Department, Thakur College of Engineering & Technology</span></div>
            </div>

            <div className="NationalConference-notice">
              The conference adopted a rigorous review process, resulting in the selection of 50 papers for presentation.
            </div>

            <p className="valedictory-text">
              <strong>Valedictory Session:</strong> The conference proceeded for valedictory session
              by <strong>Dr. Yelloji-Rao Mirajkar</strong>, International Convener, Global Indian
              Scientists and Technocrats Forum, followed by Best Research Paper Awards and certificate
              distribution.
            </p>
          </div>
        </section>

        <section id="awards" className="NationalConference-awards-section">
          <h2><FaTrophy /> Best Research Paper Awards</h2>
          <div className="NationalConference-table-wrap">
            <table className="NationalConference-table">
              <thead>
                <tr>
                  <th>Track</th>
                  <th>Award</th>
                  <th>Title</th>
                  <th>Authors</th>
                </tr>
              </thead>
              <tbody>
                {awardsData.map((row, idx) => (
                  <tr key={idx}>
                    <td className={row.trackClass}>{row.track}</td>
                    <td>
                      <span className={row.award === 'First' || row.award === 'Winner' ? 'text-green' : 'text-orange'}>
                        {row.award}
                      </span>
                    </td>
                    <td className="paper-title">{row.title}</td>
                    <td className="paper-authors">{row.authors}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default NationalConference;
